import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const MESSAGE_SCROLL_PADDING_Y = 24;

export const aiAgentColors = {
    gradient: {
        blue: "#70A2FF",
        lightBlue: "#03C2EB",
        green: "#4BE2BE",
    },
    lightBlue: "#D2F1FC",
};

export const AI_GRADIENT_SOFT = `linear-gradient(189deg, rgba(168, 247, 207, 0.20) -8.84%, rgba(166, 192, 255, 0.20) 21.09%, rgba(255, 255, 255, 0.20) 92.43%)`;

export const AI_GRADIENT_GREEN = `linear-gradient(90deg, rgba(112, 162, 255, 0.2) 0.69%, rgba(3, 194, 235, 0.2) 72.43%, rgba(75, 226, 190, 0.2) 99.61%)`;
export const AI_GRADIENT_GREEN_SOFT = `linear-gradient(270deg, rgba(168, 247, 207, 1) 0.12%, rgba(166, 192, 255, 1) 99.77%)`;
export const AI_GRADIENT_GREEN_ACTIVE = `linear-gradient(90deg, rgba(112, 162, 255, 0.28) 0.7%, rgba(3, 194, 235, 0.28) 70%, rgba(75, 226, 190, 0.28) 100%)`;
export const AI_GRADIENT_GREEN_BLUE = `linear-gradient(90deg, #3969E0 0%, #24BD98 100%)`;

export const AI_AGENT_STROKE = `linear-gradient(270deg, rgba(150, 106, 255, 0.20) 0.12%, rgba(104, 188, 254, 0.20) 99.77%)`;

export const WHITE_LINEAR_GRADIENT = `linear-gradient(${colorsPalettes.carbon[0]} 0 0)`;

export const AI_OUTREACH_BUTTON_GRADIENT = `linear-gradient(90deg, #70a2ff 1%, #4be2be 100%)`;

export const aiAgentBoxBorderStroke = css`
    position: relative;

    background-color: ${colorsPalettes.carbon[0]};

    /* Fallback: solid border */
    border: 1px solid ${colorsPalettes.purple[100]};

    /* Browsers with gradient and mask support */
    @supports (background: ${AI_AGENT_STROKE}) and
        ((mask: ${WHITE_LINEAR_GRADIENT}) or (-webkit-mask: ${WHITE_LINEAR_GRADIENT})) {
        border: none;

        & > * {
            isolation: isolate;
        }

        &:before {
            content: "";

            position: absolute;
            inset: 0;
            border-radius: inherit;
            padding: 1px;
            z-index: 0;

            background: ${AI_AGENT_STROKE};
            -webkit-mask:
                ${WHITE_LINEAR_GRADIENT} content-box,
                ${WHITE_LINEAR_GRADIENT};
            -webkit-mask-composite: destination-out;
            mask:
                ${WHITE_LINEAR_GRADIENT} content-box,
                ${WHITE_LINEAR_GRADIENT};
            mask-composite: exclude;
        }
    }
`;

export const StyledMessageBubble = styled.div`
    ${aiAgentBoxBorderStroke};

    border-radius: 8px;
    padding: 16px;
`;

export const StyledAIOutreachIconButton = styled(IconButton)`
    background: ${AI_OUTREACH_BUTTON_GRADIENT};
`;
